import { getConfig } from "@/lib/api";

const TRACK_KEY = "sl_tracking";
export const CONSENT_KEY = "sl_cookie_consent";
const UTM = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];
const GA_MAP = { Lead: "generate_lead", InitiateCheckout: "begin_checkout", Purchase: "purchase" };

let loaded = false;
const queue = [];

export function captureTracking() {
  const params = new URLSearchParams(window.location.search);
  const saved = JSON.parse(sessionStorage.getItem(TRACK_KEY) || "{}");
  UTM.forEach((k) => {
    const v = params.get(k);
    if (v) saved[k] = v;
  });
  sessionStorage.setItem(TRACK_KEY, JSON.stringify(saved));
}

const device = () => {
  const ua = navigator.userAgent;
  if (/iPad|Tablet/i.test(ua)) return "tablet";
  if (/Mobi|Android|iPhone/i.test(ua)) return "mobile";
  return window.innerWidth < 768 ? "mobile" : "desktop";
};

export function getTracking() {
  const saved = JSON.parse(sessionStorage.getItem(TRACK_KEY) || "{}");
  const base = Object.fromEntries(UTM.map((k) => [k, saved[k] || ""]));
  return { ...base, pagina: window.location.href, dispositivo: device() };
}

export const getConsent = () => localStorage.getItem(CONSENT_KEY);

function injectPixel(id) {
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", id);
}

function injectGA(id) {
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { send_page_view: false });
}

function fire(name, params) {
  if (name === "PageView") {
    window.fbq?.("track", "PageView");
    window.gtag?.("event", "page_view", { page_location: window.location.href });
    return;
  }
  window.fbq?.("track", name, params);
  const ga = GA_MAP[name];
  if (ga) window.gtag?.("event", ga, params?.value ? { value: params.value, currency: params.currency } : {});
}

export async function loadAnalytics() {
  if (loaded || getConsent() !== "all") return;
  loaded = true;
  const cfg = await getConfig();
  if (cfg.meta_pixel_id) injectPixel(cfg.meta_pixel_id);
  if (cfg.ga4_id) injectGA(cfg.ga4_id);
  fire("PageView");
  while (queue.length) {
    const [n, p] = queue.shift();
    fire(n, p);
  }
}

export function track(name, params) {
  if (getConsent() === "necessary") return;
  if (!loaded) {
    queue.push([name, params]);
    return;
  }
  fire(name, params);
}

let firstView = true;
export function trackPageView() {
  if (firstView) {
    firstView = false;
    loadAnalytics();
    return;
  }
  if (loaded) fire("PageView");
}
